
class PressQuotes extends HTMLElement {
	constructor() {
		super();

		const interval = (parseInt(this.getAttribute('interval')) || 5) * 1000;

		setInterval(() => {
			const active = this.querySelector('.quote--active');
			let next = active.nextElementSibling;
			if (!next || !next.classList.contains('quote')) {
				next = this.querySelector('.quote');
			}
			active.classList.remove('quote--active');
			active.classList.add('quote--fade-out');
			next.classList.add('quote--active');
			setTimeout(() => {
				active.classList.remove('quote--fade-out');
			});
		}, interval);
	}
}

customElements.define('press-quotes', PressQuotes);